import { z } from 'zod';

export const DOCUMENT_TYPES = [
  'offer_letter',
  'contract',
  'id_proof',
  'certificate',
  'resume',
  'appraisal',
  'nda',
  'other',
] as const;
export const documentTypeEnum = z.enum(DOCUMENT_TYPES);
export type DocumentType = z.infer<typeof documentTypeEnum>;

/**
 * Metadata accompanying a document upload — the file itself arrives as
 * multipart form data (see `document.routes.ts`), validated separately by
 * multer's `fileFilter`. Ported from Office_project's `Document` model.
 */
export const uploadDocumentSchema = z.object({
  name: z.string().trim().min(1, 'Document name is required').max(200),
  type: documentTypeEnum.default('other'),
  notes: z.string().trim().max(1000).optional().or(z.literal('')),
});

export type UploadDocumentInput = z.infer<typeof uploadDocumentSchema>;
